
import React from 'react';
import { observer } from 'mobx-react';
import Select from 'react-select';
import 'react-select/dist/react-select.css';

export default observer(({ form, postId }) => (
    <div className="post-message-form">
        <div className="post-message-button-cancel" onClick={() => { form.hide(); form.reset(); }}><img alt="Close" src={require("../../assets/images/button-close.svg")} /></div>
        <form onSubmit={form.onSubmit} >

            <div className="form-row form-row-1">
                <div className="form-field" id={"form-input-" + form.$('postid').id}>

                    <div className="form-field-input" >
                        <input {...form.$('postid').bind() }
                            className="input-hidden"
                            aria-describedby="name-desc"
                            type="hidden" disabled="disabled"
                        />
                    </div>
                </div>
            </div>
            <div className="form-row form-row-2">
                <div className="form-field status-field" id={"form-select-" + form.$('status').id}>
                    <div className="form-field-input" >
                        <Select
                            {...form.$('status').bind() }
                            options={form.$('status').extra}
                            clearable={false}
                            placeholder="Status"
                            resetValue={[]}
                        />
                    </div>
                </div>

            </div>
            <div className="form-row form-row-3">

                <div className="form-field message-field" id={"form-input-" + form.$('text').id}>
                    <div className="form-field-input" >
                        <textarea 
                            className="textarea"
                            {...form.$('text').bind() }
                        />
                        {/*<div className="field-error">
                            <small className="f6 db red">
                                {form.$('text').error}
                            </small>
                        </div> */}
                    </div>
                </div>
            </div>
            <div className="form-controls">
                <div className="post-messages-button-save"><span onClick={form.onSubmit}>Save</span></div>
            </div>

            <p className="form-error">{form.error}</p>
        </form>
    </div>
));




// WEBPACK FOOTER //
// ./src/components/forms/FormPostMessage.jsx